import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { selectSitetype, selectjobtype } from "../SelectOption";
import {
  getCustomerList,
  // getDealerList,
  getDispenserSrNoList,
  getServiceEngineerList,
} from "../master/AllUserDropDown";
import { getListOfUserById } from "../../Service/AllAccessGetById";
import {
  getDispatchListByDispenserSrNo,
  getWorkOrderNoDropDown,
} from "../../Service/AllWorkOrder";
import {
  getWorkOrderSrNo,
  postWorkOrderInstallation,
} from "../../Service/AllWorkOrderInstallationAPI";

import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";

const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode
const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
/* declaration of validationSchema
validation (based on the object schema provided by Yup) and display of validation errors */
const validationSchema = Yup.object({
  // serviceEngineerName: Yup.string().required("Required *"),
  jobPreference: Yup.string().required("Required *"),
  // siteType: Yup.string().required("Required *"),
  // installationAddress: Yup.string().required("Required *"),
  // dealerName:Yup.string().required("Enter dealer name"),
  // mobileNo: Yup.string()
  //   .matches(/^[0-9\s]+$/, "Enter Numbers Only")
  //   .test("valid-phone", "Invalid Mobile number", (value) => {
  //     if (!value) return false;
  //     const cleanedNumber = value.replace(/\s/g, "");
  //     return /^\d{10}$/.test(cleanedNumber);
  //   })
  //   .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
  //   .matches(phoneRegEx, "Mobile number is not valid"),
  // city: Yup.string().required("Required *")
  //   .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
  //   .min(2, "Too Short!"),
  // pincode: Yup.string()
  //   .required("Required *")
  //   .matches(pincodeRegEx, "Pincode is not valid"),
  description: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});

export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [customerName, setCustomerName] = useState([]);
  // const [dealerName, setDealerName] = useState([]);
  const [userMblNo, setUserMblNo] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [jobType, setjobType] = useState("installation");
  const [workOrderSrNo, setworkOrderSrNo] = useState("");
  const [workOrderNo, setWorkOrderNo] = useState("");
  const [dispenserSrNo, setDispenserSrNo] = useState([]);
  const [selectDispenserSrNo, setSelectDispenserSrNo] = useState("");
  const [allDispenserData, setAllDispenserData] = useState({});
  const [allDispenser, setAllDispenser] = useState([]);
  // const [status, setStatus] = useState("ready to install");
  const [status, setStatus] = useState("close and ready to install");
  const [disabled, setdisabled] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  // const [showdealer, setShowDealer] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [siteType, setSiteType] = useState(""); // Store the siteType
  const clean = (v) => (v ?? "").replace(/\r?\n|\r/g, "").trim();
  const location = useLocation();





  const searchParams = new URLSearchParams(location.search);
  const dispenser = searchParams.get("dispenser") || "N/A";
  const ticketNumber = searchParams.get("ticket") || "N/A";
  const priority = searchParams.get("priority") || "N/A";
  const roCountry = searchParams.get("roCountry") || "N/A";
  const roCity = searchParams.get("roCity") || "N/A";
  const roState = searchParams.get("roState") || "N/A";
  const roDistrict = searchParams.get("roDistrict") || "N/A";
  const roAddress = searchParams.get("roAddress") || "N/A";
  const pincode = searchParams.get("pincode") || "N/A";
  const roContact = searchParams.get("roContact") || "N/A";
  const contactPerson = searchParams.get("contactPerson") || "N/A";
  const roEmail = searchParams.get("roEmail") || "N/A";
  const seName = searchParams.get("seName") || "N/A";
  const seEmail = searchParams.get("seEmail") || "N/A";
  const seContactNumber = searchParams.get("seContactNumber") || "N/A";
  const seId = searchParams.get("seId") || "N/A";
  const pkUserId = searchParams.get("pkUserId") || "N/A";


  const roSiteType = searchParams.get("roSiteType") || "N/A";
  console.log("Dispenser:", dispenser);
  console.log("Ticket Number:", ticketNumber);
  console.log("Priority:", priority);
  console.log("roCountry:", roCountry);
  console.log("roCity :", roCity);
  console.log("roDistrict :", roDistrict);
  console.log("roState:", roState);
  console.log("roAddress", roAddress);
  console.log("pincode", pincode);
  console.log("roSiteType", roSiteType);
  console.log("roContact", roContact);
  console.log("contactPerson", contactPerson);
  console.log("roEmail", roEmail);  
  console.log("seName", seName);
  console.log("seEmail", seEmail);
  console.log("seContactNumber", seContactNumber);
 console.log("seId", seId);
  console.log("pkUserId", pkUserId);

  // const [formValues, setFormValues] = useState({
  //   dispenserSrNo: dispenser,
  //   ticketNumber: ticketNumber,
  //   priority: priority,
  //   roCountry: roCountry,
  //   roState: roState,
  //   roAddress: roAddress,
  //   roCity: roCity,
  //   pincode:pincode,
  //   contactPerson:contactPerson,
  //   roContact:roContact,
  //   roSiteType:roSiteType,
  // });

  const [formValues, setFormValues] = useState({
    dispenserSrNo: clean(dispenser),
    ticketNumber: clean(ticketNumber),
    priority: clean(priority),
    roCountry: clean(roCountry),
    roState: clean(roState),
    roCity: clean(roCity),
    roDistrict: clean(roDistrict),
    roAddress: clean(roAddress),
    pincode: clean(pincode),
    roContact: clean(roContact),
    contactPerson: clean(contactPerson),
    roEmail:clean(roEmail),
    roSiteType: clean(roSiteType),
    seName:clean(seName),
    seContactNumber:clean(seContactNumber),
    seEmail:clean(seEmail),
     seId:clean(seId),
       pkUserId:clean(pkUserId),
  });





  // const changeHandler = (e) => {
  //   setSiteType(e.value); // Store the selected siteType
  //   if (e.value === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // };


  // as per fecthed roSiteType
  // useEffect(() => {
  //   if (formValues.roSiteType === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // }, [formValues.roSiteType]);


  // const validateMobile = (value) => {
  //   let error;
  //   if (!value) {
  //     error = "Mobile number is required";
  //   } else if (!/^[0-9\s]+$/.test(value)) {
  //     error = "Enter numbers only";
  //   } else {
  //     const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
  //     if (!/^\d{10}$/.test(cleanedNumber)) {
  //       error = "Mobile number must be exactly 10 digits";
  //     } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
  //       error = "Invalid mobile number ";
  //     }
  //   }
  //   return error;
  // };

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  useEffect(() => {
    // Function call to get customers,Dealers and  Service Engineers list
    getCustomersList();
    // getDealersList();
    getServiceEngineersList();
    getWorkOrderList();
    getDispenserSrNoAllList();
    getDispatchListByDispenserSrNo()
  }, []);



  useEffect(() => {
    if (!dispenser || dispenser === "N/A") return;

    getDispatchListByDispenserSrNo(dispenser)
      .then((result) => {
        if (!result || !result.data || !result.data[0]) {
          console.log("No customer found for this dispenser");
          return null;
        }

        const customerName = result.data[0].customerFullName;

        setAllDispenserData(result.data[0]);

        setFormValues((prev) => ({
          ...prev,
          customerName: customerName,
          customerNumber: result.data[0].customerNumber,
        }));

        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        // ONLY CALL if customerName exists
        return getWorkOrderSrNo("installation", "", customerName, headers);
      })
      .then((workOrderRes) => {
        if (workOrderRes && workOrderRes.data) {
          console.log("Work Order Sr No:", workOrderRes.data);
          setworkOrderSrNo(workOrderRes.data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // swal("Failed", "Something went wrong", "error");
      });
  }, [dispenser]);






  // added this code because of naivagiton error was coimng in ticket service page
  useEffect(() => {
    const handleEnterKey = (event) => {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        const form = event.target.form;

        if (form && form.elements) {
          const index = Array.prototype.indexOf.call(form.elements, event.target);
          if (form.elements[index + 1]) {
            form.elements[index + 1].focus();
            event.preventDefault();
          }
        }
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, []);


  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // Function declaration of get dealers list
  // const getDealersList = async () => {
  //   await getDealerList().then((result) => {
  //     setDealerName(result);
  //   });
  // };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };

  const getDispenserSrNoAllList = async () => {
    await getDispenserSrNoList().then((result) => {
      setDispenserSrNo(result);
    });
  };
  const getWorkOrderList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      // const status= ["ready to install"]
      await getWorkOrderNoDropDown(status, headers)
        .then((result) => {
          if (result?.data?.length !== 0) {
            console.log("Work Order List", result.data);
            let tempServiceArray = result.data.map((obj) => {
              // let Name = obj.split(",");
              return {
                id: `${obj}`,
                value: `${obj}`,
                label: `${obj}`,
              };
            }).reverse();

            setWorkOrderNo(tempServiceArray);
            console.log("Work OrderNo DropDown", result.data);
          }
        })
        .catch((error) => {
          console.log("Work Order List Error", error);
        });
      return setWorkOrderNo;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Formik //Formik provides the Form, Field and ErrorMessage
      initialValues={{
        //declaration of initialValues
        generateUniqueDispenserNo: "",
        workOrderNo: "",
        installationDate: "",
        installationTime: "",
        serviceEngineerName: "",
        serviceEngineerMobNo: "",
        // RoManagerEmail:"",
        // RoManagerMobNo:"",
        // RoManagerName:"",
        roManagerName:"",
        roManagerEmail:"",
        roManagerMobNo:"",
        customerName: "",
        customerMobNo: "",
        // dealerName: "",
        // dealerMobNo: "",
        jobType: "",
        jobPreference: "",
        dispenserType: "",
        siteType: "",
        installationAddress: "",
        country: "",
        state: "",
        district: "",
        roSiteType: "",
        city: "",
        pincode: "",
        description: "",
        dispenserSrNo: "",
        ticketNumber: "",
        priority: "",
        roCountry: "",
        roCity: "",
        roState: "",
        roAddress: "",
        fkRoManagerId:"",

      }}
      validationSchema={validationSchema} // function call to validationSchema
      onSubmit={async (values, { resetForm }) => {
        // declaration of onSubmit callback
        try {
          // code that we will 'try' to run
          setisLoaded(true);
          setdisabled(true);
          const loginRole = sessionStorage.getItem("role");
          const pkUserId = sessionStorage.getItem("pkUserId");
          const data = {
            // All Object for Create Installation data
            workOrderSerialNo: workOrderSrNo,
            // generateUniqueDispenserNo: values.generateUniqueDispenserNo,
            installationDate: moment(selectedDate, "DD/MMM/yyyy").format(
              "yyyy-MM-DD"
            ),
            // installationTime: displayFormattedTime,
            installationTime: moment(displayFormattedTime, "hh:mm:ss A").format(
              "hh:mm:ss A"
            ),
            dispenserType: allDispenserData.modelName,
            fkServiceEngineerId: formValues.seId,
            fkCustomerId: allDispenserData.fkCustomerId,
            // fkDealerId: allDispenserData.fkDealerId,
            fkBackOfficeId: loginRole === "back office" ? `${pkUserId}` : "",
            // serviceEngineerName: values.serviceEngineerName,
            // serviceEngineerMobNo: userMblNo,
            serviceEngineerName:formValues.seName,
            serviceEngineerMobNo:formValues.seContactNumber,
            roManagerName:formValues.contactPerson,
            roManagerMobNo:formValues.roContact,
            roManagerEmail:formValues.roEmail,
            fkRoManagerId:formValues.pkUserId,
            customerName: allDispenserData.customerFullName,
            customerMobNo: allDispenserData.customerMobileNo,
            // customerName:formValues.contactPerson,
            // customerMobNo:formValues.roContact,
            // dealerName: allDispenserData.dealerName,
            // dealerMobNo: allDispenserData.mobileNo,
            // dealerName: values.dealerName,
            // dealerMobNo: values.mobileNo,
            jobType: jobType,
            jobPreference: values.jobPreference,
            // siteType: values.siteType,
            siteType: formValues.roSiteType,
            installationAddress: formValues.roAddress,
            country: formValues.roCountry,
            state: formValues.roState,
            district: formValues.roDistrict,
            city: formValues.roCity,
            // pincode: values.pincode,
            description: values.description,
            // generateUniqueDispenserNo: formValues.dispenserSrNo,
            generateUniqueDispenserNo: clean(formValues.dispenserSrNo),
            ticketNumber: formValues.ticketNumber,
            priority: formValues.priority,
            // roCity: formValues.roCity,
            // roAddress: formValues.roAddress,
            // roState: formValues.roState,
            // roCountry: formValues.roCountry,
            pincode: formValues.pincode,
          };
          console.log("Work OrderInstallation Data", data);

          await postWorkOrderInstallation(data)
            .then((result) => {
              console.log("Work Order Installation", result);

              setisLoaded(false);
              swal("Great", "Installation Work order created successfully...", "success");

  resetForm()
              // setTimeout(() => {

              //   resetForm();
              //   window.location.href = '/Callcenter/TicketServiceTech';

              // }, 5000);
            })
            .catch((error) => {
              setisLoaded(false);
              console.log("Installation Error :-", error);
              if (error.response.status === 400) {
                console.log("error.response.data :-", error.response.data);
                let instalVal = error?.response?.data;
                if (instalVal?.generateUniqueDispenserNo !== undefined) {
                  swal("Failed", "Please Select Dispenser Sr No", "warning");
                  return false;
                }
                if (instalVal?.serviceEngineerName !== undefined) {
                  swal(
                    "Failed",
                    "Please Select Service Engineer name",
                    "warning"
                  );
                  return false;
                }
                if (instalVal?.serviceEngineerMobNo !== undefined) {
                  swal(
                    "Failed",
                    "Please Enter Service Engineer Mobile Number",
                    "warning"
                  );
                  return false;
                }
                if (instalVal?.siteType !== undefined) {
                  swal("Failed", "site type should not empty", "warning");
                  return false;
                }
                if (instalVal?.dispenserType !== undefined) {
                  swal("Failed", "Please Enter Dispenser Type", "warning");
                  return false;
                }
                // if (instalVal?.country !== undefined) {
                //   swal("Failed", "Please Select Country", "warning");
                //   return false;
                // }
                // if (instalVal?.state !== undefined) {
                //   swal("Failed", "Please Select State", "warning");
                //   return false;
                // }
                // if (instalVal?.city !== undefined) {
                //   swal("Failed", "Please Enter City", "warning");
                //   return false;
                // }
                if (instalVal?.pincode !== undefined) {
                  swal("Failed", "Please Enter Pincode", "warning");
                  return false;
                }
              } else {
                swal("Failed", "Installation Failed", "error");
              }
            });
        } catch (error) {
          //code to run if there are any problems
          console.log(error);
          setisLoaded(false);
        }
      }}
    >
      {(formik) => {
        //Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting, values, errors, touched } = formik;
        const isinstallatiobutton = displayFormattedTime && selectedDate;

        // const dealerCheck = formValues.roSiteType !== "COCO"
        //   ? values.dealerName && values.mobileNo
        //   : true;  // If siteType is COCO, dealerName and mobileNo are not required

        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="installation-list"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <Row>
                      <h5 className="head mb-4">
                        Create Installation Work Order
                      </h5>
                      <h5 className="SrNo mb-4" align="right">
                        Installation Sr No : {workOrderSrNo}
                      </h5>
                    </Row>
                    {/* react-final-form */}
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          {/* <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Dispenser Sr No *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Dispenser for Installation"
                                direction="bottom"
                              >
                                <Select
                                  name="generateUniqueDispenserNo"
                                  placeholder="Select Dispenser for Installation"
                                  options={dispenserSrNo}
                                  onChange={async (e) => {
                                    formik.setFieldValue(
                                      "generateUniqueDispenserNo",
                                      e.value
                                    );
                                    setSelectDispenserSrNo(e.value);
                                    await getDispatchListByDispenserSrNo(
                                      e.value
                                    ).then((result) => {
                                      console.log(
                                        "getDispatchListByDispenserSrNo result :-",
                                        result
                                      );
                                      console.log(
                                        "get All Dispenser List",
                                        result.data[0].customerFullName
                                      );
                                      setAllDispenserData(result.data[0]);
                                      const token =
                                        sessionStorage.getItem("token");
                                      const headers = {
                                        Authorization: `Bearer ${token}`,
                                      };
                                      const customerName =
                                        result.data[0].customerFullName;
                                      try {
                                        getWorkOrderSrNo(
                                          "installation",
                                          "",
                                          customerName,
                                          headers
                                        )
                                          .then((result) => {
                                            console.log(
                                              "Work Order Field Visit Sr No",
                                              result
                                            );
                                            setworkOrderSrNo(result.data);
                                          })
                                          .catch((error) => {
                                            console.log(
                                              "Work Order Field Visit Error",
                                              error
                                            );
                                          });
                                      } catch (error) {
                                        console.log(error);
                                        swal(
                                          "Failed",
                                          "Something went wrong please check your internet",
                                          "error"
                                        );
                                      }
                                    });
                                    return setAllDispenserData;
                                  }}
                                />
                              </ToolTip>
                            </div>
                          </div> */}





                          <div className="form-group">
                            <label className="Label mb-1">
                              Dispenser Sr No

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Ticket Number
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.ticketNumber}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Priority

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.priority}
                              readOnly
                            />
                          </div>

                        </Col>


                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dispenser Config{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Config"
                              value={allDispenserData.modelName}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Installation Date *{" "}
                            </label>
                            <br />
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Installation Date"
                                direction="bottom"
                              >
                                <DatePicker
                                  showIcon
                                  closeOnScroll={true}
                                  className="form-control"
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Select Installation Date"
                                  selected={selectedDate}
                                  onChange={(date) => {
                                    setSelectedDate(date);
                                  }}
                                  // minDate={new Date()} // Set the minimum selectable date to today
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Installation Time *{" "}
                            </label>
                            <br />
                            <div className="time-wrapper">
                              <div className="allTime">
                                <input
                                  type="time"
                                  onChange={handleTimeChange}
                                  className="form-control"
                                  step="1"
                                />
                              </div>
                              <div className="addTime">
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Time from Widget"
                                    direction="bottom"
                                  >
                                    <Field
                                      className="form-control"
                                      name="installationTime"
                                      placeholder="Select Time from Widget"
                                      value={displayFormattedTime}
                                      readOnly
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                       
                        <Col md={6} className="mb-3">
                          {/* <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Service Engineer Name *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Service Engineer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Service Engineer Name"
                                  options={serviceEngineerName}
                                  onChange={async (e) => {
                                    formik.setFieldValue(
                                      "serviceEngineerName",
                                      e.value
                                    );
                                    setSelectedServiceEngineer(e.id);
                                    const token =
                                      sessionStorage.getItem("token");
                                    const headers = {
                                      Authorization: `Bearer ${token}`,
                                    };
                                    await getListOfUserById(e.id, headers).then(
                                      (result) => {
                                        console.log(
                                          "getListOfUserById",
                                          result.data
                                        );
                                        setUserMblNo(result.data.mobileNo);
                                      }
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="serviceEngineerName"
                              component={TextError}
                            />
                          </div> */}

                          <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Name</label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter country" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                // placeholder="Enter City"
                                // autoComplete="off"
                                value={formValues.seName} 
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>


                          
                        </Col>
                        <Col md={6} className="mb-3">
                          {/* <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Service Engineer Mobile No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="serviceEngineerMobNo"
                              value={userMblNo}
                              placeholder="Mobile No."
                              readOnly
                            />
                          </div> */}

                           <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Mobile No</label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter country" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                // placeholder="Enter City"
                                // autoComplete="off"
                                value={formValues.seContactNumber } 
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Name </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                               
                                value={formValues.contactPerson}
                                readOnly
                              />

                            </div>
                           
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Contact Number </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                               
                                value={formValues.roContact}
                                readOnly
                              />

                            </div>
                           
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Email </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                               
                                value={formValues.roEmail}
                                readOnly
                              />

                            </div>
                           
                          </div>
                        </Col>
                        
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Job Reference *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Job Reference"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Job Reference"
                                  options={selectjobtype}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "jobPreference",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="jobPreference"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Site Type *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Site Type"
                                direction="bottom"
                              >
                                <Select
                                  name="siteType"
                                  placeholder="Select Site Type"
                                  options={selectSitetype}
                                  onChange={(val) => {
                                    changeHandler(val);
                                    formik.setFieldValue("siteType", val.value);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteType"
                              component={TextError}
                            />
                          </div>
                        </Col> */}

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Labelmb-1">Site Type </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roSiteType}
                                readOnly
                              />

                            </div>
                            <ErrorMessage name="roSiteType" component={TextError} />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Customer Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              name="customerName"
                              placeholder="Customer Name"
                              value={allDispenserData.customerFullName}
                              // value={formValues.contactPerson}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Mobile No{" "}
                            </label>
                            <Field
                              type="text"
                              name="customerMobNo"
                              value={allDispenserData.customerMobileNo}
                              // value={formValues.roContact}
                              className="form-control"
                              placeholder="Customer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                        {/* {showdealer ? (
                          <>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  Dealer Name
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Dealer Name "
                                  name="dealerName"
                                  autoComplete="off"
                                // value={allDispenserData.dealerName}
                                // readOnly
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">

                              <div className="form-group">
                                <label className="Label mb-1">Dealer Mobile No</label>
                                <Field
                                  type="text"
                                  name="mobileNo"
                                  autoComplete="off"
                                  maxLength="10"
                                  className={`form-control ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter Dealer Mobile No"
                                  validate={validateMobile}
                                />
                                <ErrorMessage name="mobileNo" component="div" className="text-danger" />
                              </div>
                            </Col>
                          </>
                        ) : null} */}

                        <Col md={6} className="mb-3">
                          {/* <div className="form-group">
                            <label className="Label mb-1">RO Country</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >
                                <CountryDropdown
                                  className="form-control"
                                  id="country"
                                  value={country}
                                  onChange={(val) => setCountry(val)}
                                  priorityOptions={["IN"]}
                                />
                              </ToolTip>
                            </div>
                          </div> */}
                          <div className="form-group">
                            <label className="Label mb-1">RO Country </label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter country" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                // placeholder="Enter City"
                                // autoComplete="off"
                                value={formValues.roCountry}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>



                        </Col>



                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> RO State</label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Select State"
                                direction="bottom"
                              > */}
                              {/* <RegionDropdown
                                  className="form-control"
                                  id="state" */}

                              {/* // country={country}
                                  // value={state}
                                  // onChange={(val) => setState(val)} */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                value={formValues.roState}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO District</label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                                value={formValues.roDistrict}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO City </label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter City" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                // placeholder="Enter City"
                                // autoComplete="off"
                                value={formValues.roCity}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          {/* <div className="form-group">
                            <label className="LabelNew mb-1">
                             Ro Address *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Site Address"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="2"
                                  maxLength={100}
                                  className="form-control"
                                  name="installationAddress"
                                  placeholder="Enter Site Address"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="installationAddress"
                              component={TextError}
                            />
                          </div> */}

                          <div className="form-group">
                            <label className="Label mb-1">RO Adress</label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter adress" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                maxLength={100}

                                value={formValues.roAddress}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>


                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Pincode </label>
                            <div className="example-wrapper">

                              <Field
                                type="text"
                                className="form-control"
                                // name="pincode"
                                // placeholder="Enter Pin Code"
                                // maxLength="6"
                                // autoComplete="off"
                                value={formValues.pincode}
                                readOnly
                              />

                            </div>
                            {/* <ErrorMessage
                              name="pincode"
                              component={TextError}
                            /> */}
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Description *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="4"
                                  maxLength={100}
                                  className="form-control"
                                  name="description"
                                  placeholder="Enter Description"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="description"
                              component={TextError}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !isinstallatiobutton /* || !dealerCheck */}
                        >
                          Create Installation WO
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};

